import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';

@Injectable()

export class Utilities {

  constructor(public pt: Platform) {}

  getPlatformData() {
    let platform = 'undefined';

    if (this.pt.is('android')) {
      platform = 'android';
    } else if(this.pt.is('core')) {
      platform = 'desktop';
    } else if(this.pt.is('ios')) {
      platform = 'ios';
    } else if(this.pt.is('ipad')) {
      platform = 'ipad';
    } else if(this.pt.is('iphone')) {
      platform = 'iphone';
    } else if(this.pt.is('mobile')) {
      platform = 'mobile';
    } else if(this.pt.is('mobileweb')) {
      platform = 'mobileweb';
    } else if(this.pt.is('tablet')) {
      platform = 'tablet';
    } else if(this.pt.is('windows')) {
      platform = 'windows';
    }

    return {
      platform: platform,
      userAgent: this.pt.userAgent(),
      browser: this.getBrowser()
    }
  }

  timeLeft(end) {
    // TODO: Time left calculate
    if (end) {
      return '10 minutos';
    } else {
      return 'más de 10 minutos';
    }
  }

  getBrowser() {
    let userAgent = this.pt.userAgent();
    let browsers = {chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i};

    for (let key in browsers) {
        if (browsers[key].test(userAgent)) {
            return key;
        }
    };
    return 'unknown';
  }
}
// end file



// WEBPACK FOOTER //
// ./src/providers/utilities.ts